import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'

import App from './App'

const lifecycles = singleSpaReact({
    React,
    ReactDOM,
    errorBoundary(err, info, props) {
        return <div>Erro ao carregar aplicação Páginas deslogadas</div>
    },
    rootComponent: App,
})

export const { mount, unmount, bootstrap } = lifecycles
